<template>
  <div>
    <Header/>
    <ProjectOverviewBody>
      <ProjectOverview
        title="My Website"
        description="With a will to explore WEB developement and to craft my own website, I went on building my portfolio. With VueJS, I achieved to make it modular so I can easely add/remove/modify content and thanks to Bootstrap the website is responsive."
        timeline="August - September 2020"
        team="Alone"
        image="website/Website_Logo.png"

        :tags="['WEB', 'HTML/CSS', 'VueJS', 'Bootstrap']"

        :keypoints="[
            'Easely add/remove content with VueJS',
            'Responsive',
            'Learned a lot about WEB developpement'
        ]"

        :categories="[
            'WEB',
            'WEB',
            'WEB'
        ]"
      />
      <ProjectOverviewCarrousel
        :images="[
            'website/Website_Screenshot_2.jpg',
            'website/Website_Screenshot_3.jpg'
        ]"

        style="margin: 100px auto 100px auto"
      />
    </ProjectOverviewBody>
  </div>
</template>

<script>
import Header from "@/components/Header";
import ProjectOverviewBody from "@/components/ProjectOverviewBody";
import ProjectOverview from "@/components/ProjectOverview";
import ProjectOverviewCarrousel from "@/components/ProjectOverviewCarrousel";
export default {
name: "Website",
  components: {ProjectOverviewCarrousel, ProjectOverview, ProjectOverviewBody, Header}
}
</script>

<style scoped>

</style>